module.exports = __webpack_public_path__ + "img/63.dd08593c.jpg";